const META_PIXEL_ID = '1584241515962496'

declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

export function initMetaPixel(): void {
  // If fbq already exists (real script loaded), skip re-init
  if (typeof window.fbq === 'function' && (window.fbq as any).loaded) {
    console.log('[Meta Pixel] Already initialized')
    return
  }

  // Create the fbq stub that queues calls until the real script loads
  const n: any = (window.fbq = function (...args: any[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Load the fbevents.js script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'

  // Insert script - with fallback if no existing script tags
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    ;(document.head || document.body).appendChild(script)
  }

  // Add noscript fallback pixel
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
  document.body.appendChild(img)

  // Initialize pixel
  window.fbq('init', META_PIXEL_ID)
  console.log('[Meta Pixel] Initialized with ID:', META_PIXEL_ID)
}

export function trackPageView(): void {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'PageView')
    console.log('[Meta Pixel] Event fired: PageView')
  } else {
    console.warn('[Meta Pixel] fbq not available - PageView not fired')
  }
}

export function trackAddToCart(): void {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'AddToCart', {
      content_name: 'Sensory Feeding Victory',
      content_type: 'product',
      value: 6.99,
      currency: 'USD',
    })
    console.log('[Meta Pixel] Event fired: AddToCart', {
      content_name: 'Sensory Feeding Victory',
      value: 6.99,
      currency: 'USD',
    })
  } else {
    console.warn('[Meta Pixel] fbq not available - AddToCart not fired')
  }
}
